import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

import {
  HOME,
  SETTINGS,
  TOURS,
  AUTH,
  FORBIDDEN,
  NOT_FOUND,
  HOME_NAME,
  SETTINGS_NAME,
  TOURS_NAME,
  AUTH_NAME,
  FORBIDDEN_NAME,
  NOT_FOUND_NAME
} from "./type";

import { ADMIN, MANAGER } from "./roles";

Vue.use(VueRouter);

import { ifAuthenticated } from "./right";

const routes = [
  {
    path: HOME,
    name: HOME_NAME,
    component: Home,
    beforeEnter: ifAuthenticated,
    meta: {
      roles: [ADMIN, MANAGER]
    }
  },
  {
    path: AUTH,
    name: AUTH_NAME,
    component: () => import(/* webpackChunkName: "auth" */ "../views/Auth.vue")
  },
  {
    path: SETTINGS,
    name: SETTINGS_NAME,
    component: () =>
      import(/* webpackChunkName: "settings" */ "../views/Settings.vue"),
    beforeEnter: ifAuthenticated,
    meta: {
      roles: [ADMIN]
    }
  },
  {
    path: TOURS,
    name: TOURS_NAME,
    component: () =>
      import(/* webpackChunkName: "tours" */ "../views/Tours.vue"),
    beforeEnter: ifAuthenticated,
    meta: {
      roles: [ADMIN]
    }
  },
  {
    path: FORBIDDEN,
    name: FORBIDDEN_NAME,
    component: () =>
      import(/* webpackChunkName: "forbidden" */ "../views/Forbidden.vue")
  },
  {
    path: NOT_FOUND, // /Всегда самым последним
    name: NOT_FOUND_NAME,
    component: () =>
      import(/* webpackChunkName: "not_found" */ "../views/NotFound.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
